var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PollResultsChartPie',{attrs:{"data-label-callback":_vm.dataLabel,"tooltip-label-callback":_vm.tooltipLabel,"chart-pie-data":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }